<template>
  <div class="switch">
    <label class="switch-label">
      <input type="checkbox" :value="value" :checked="value" @change="toggleSwitch" />
      <span class="switch-input"></span>
    </label>
  </div>
</template>

<script>
export default {
  name: "ClassicSwitch",
  props: ["value"],
  methods: {
    toggleSwitch() {
      const isChecked = event.target.checked;
      this.$emit('input', isChecked)
    }
  }
}
</script>

<style scoped lang="scss">
.switch {
  display: flex;
  align-items: center;

  &-label {
    background: #efefef;
    border-radius: 50px;
    height: 2.4rem;
    display: block;
    width: 4.1rem;
    position: relative;
    cursor: pointer;
    transition: background 0.4s ease;
  }

  &-input {
    position: absolute;
    width: 20px;
    height: 20px;
    background: #a6a6a6;
    border-radius: 50%;
    top: 2px;
    left: 2px;
    transition: background 0.4s ease, transform 0.6s ease;

    input:checked ~ & {
      background: #77b017;
      transform: translateX(16px);
    }
  }
}
</style>